import styled from 'styled-components';
import { Popover } from 'antd';

const EbzPopover = styled(Popover)`
  //popover
  .ant-popover-arrow {
    display: none !important;
  }

  .ant-popover-content {
    position: relative;
    top: -10px;
  }
`;
export default EbzPopover;
